import { c as _c } from "react/compiler-runtime";
import { SpinnerFullPage } from "@repo/ui/components/ui/spinner-full-page";
import { RouterProvider } from "@tanstack/react-router";
import { useSetAtom } from "jotai";
import { ThemeProvider } from "next-themes";
import React, { useRef } from "react";
import ReactDOM from "react-dom/client";
import { createRouter } from "@/router";
import { authClient } from "./clients/authClient";
import { userAtom } from "./lib/atoms/user.atoms";
import { useOnce } from "./lib/hooks/useOnce";
import "./style.css";
import { jsx as _jsx } from "react/jsx-runtime";
const ROOT_ELEMENT_ID = "app";
const rootElement = document.getElementById(ROOT_ELEMENT_ID);
if (!rootElement) {
  throw new Error(`Root element with ID '${ROOT_ELEMENT_ID}' not found.`);
}
const router = createRouter();
function RouterWrapper() {
  const {
    data: session,
    isPending
  } = authClient.useSession();
  const setUser = useSetAtom(userAtom);

  // Better Auth refetches the session after sign-up/sign-in/sign-out, which
  // flips isPending back to true. Unmounting the router on every one of those
  // threw away all page state — sign-up snapped back to step 1 instead of
  // showing the "check your inbox" panel. Only the very first load blocks.
  const hasResolved = useRef(false);
  if (!isPending) {
    hasResolved.current = true;
  }

  // Keep the last known session so a refetch doesn't briefly report the user as
  // signed out, which would trip the route guards mid-flight.
  const lastSession = useRef(session);
  if (!isPending) {
    lastSession.current = session;
  }
  useOnce(() => {
    if (session) {
      setUser(session.user);
    }
  });
  if (isPending && !hasResolved.current) {
    return /*#__PURE__*/_jsx(SpinnerFullPage, {
      message: "Laddar sida..."
    });
  }
  return /*#__PURE__*/_jsx(RouterProvider, {
    router: router,
    context: {
      auth: lastSession.current
    }
  });
}
function App() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(React.StrictMode, {
      children: /*#__PURE__*/_jsx(ThemeProvider, {
        attribute: "class",
        defaultTheme: "light",
        forcedTheme: "light",
        disableTransitionOnChange: true,
        children: /*#__PURE__*/_jsx(RouterWrapper, {})
      })
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(/*#__PURE__*/_jsx(App, {}));
}